import { Component, Input } from '@angular/core';

@Component({
  selector: 'rmt-input-loader',
  templateUrl: 'rmt-input-loader.html'
})
export class RmtInputLoaderComponent {
  @Input() isReady: boolean = false;
  @Input() spinnerType: string = "";
  
  constructor() {
  }
}



// WEBPACK FOOTER //
// ./src/components/rmt-input-loader/rmt-input-loader.ts